import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "7245b5d5-200a-419a-83da-07349ef1757e",
    options: {
      imageUrl: `${config.ASSETS_URL}/04/04/task/task-2-1.svg`,
    },
  },
  {
    id: "251a1124-eb68-4a1d-ad76-115885736d94",
    options: {
      imageUrl: `${config.ASSETS_URL}/04/04/task/task-2-2.svg`,
    },
  },
  {
    id: "7194dcd7-14cc-400b-a3be-76066d61d63f",
    options: {
      imageUrl: `${config.ASSETS_URL}/04/04/task/task-2-3.svg`,
    },
  },
  {
    id: "776a2c40-c433-4247-93ad-a95f7aeae6d6",
    options: {
      imageUrl: `${config.ASSETS_URL}/04/04/task/task-2-4.svg`,
    },
  },
];

export const task: Task = {
  id: "3bfdc874-be37-4411-8845-b0b926701b2d",
  solutionType: "order",
  type: "orderImages",
  options: {
    shuffle: true,
    orientation: "horizontal",
    imageViewType: "fill",
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "order",
  data: [
    "7194dcd7-14cc-400b-a3be-76066d61d63f",
    "776a2c40-c433-4247-93ad-a95f7aeae6d6",
    "7245b5d5-200a-419a-83da-07349ef1757e",
    "251a1124-eb68-4a1d-ad76-115885736d94",
  ],
};
